import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IAsset, IAssetAssign, IAssetForm, IAssetMaintenaceForm, IMyAsset } from "./models/assets";

@Injectable({
  providedIn: "root",
})
export class AssetsService {
  public assetsList: IAsset[];

  public baseUrl: string = "/asset";

  constructor(private _httpClient: HttpClient) {}

  async getMine() {
    return this._httpClient.get<IMyAsset[]>("/me/asset").toPromise();
  }

  async getAllAssets() {
    return this._httpClient
      .get("/asset")
      .toPromise()
      .then((response: IAsset[]) => {
        this.assetsList = response;
        return response;
      });
  }

  async deleteAsset(id: number) {
    return this._httpClient.delete(`/asset/${id}`).toPromise();
  }

  async get(id: number) {
    return this._httpClient.get<IAsset>(`/asset/${id}`).toPromise();
  }

  async createAsset(data: IAssetForm, updateList: boolean = true) {
    return this._httpClient
      .post("/asset", data)
      .toPromise()
      .then(async (response) => {
        if (updateList) {
          await this.getAllAssets();
        }
        return response;
      });
  }

  async updateAsset(id: number, data: IAssetForm) {
    return this._httpClient
      .put(`/asset/${id}`, data)
      .toPromise()
      .then(async () => {
        await this.getAllAssets();
      });
  }

  async assignAsset(data: IAssetAssign) {
    return this._httpClient.post("/asset-user", data).toPromise();
  }

  async unassignAsset(id: number) {
    return this._httpClient.put(`/asset/unassign/${id}`, {}).toPromise();
  }

  async deleteFile(id: number) {
    return this._httpClient.delete(`/asset-file/${id}`).toPromise();
  }

  async deleteCurrentMaintenance(id: number) {
    return this._httpClient.delete(`/asset-maintenance/${id}`).toPromise();
  }

  async addMaintenance(data: IAssetMaintenaceForm) {
    return this._httpClient.post("/asset-maintenance", data).toPromise();
  }

  async editMaintenance(id: number, data: IAssetMaintenaceForm) {
    return this._httpClient.put(`/asset-maintenance/${id}`, data).toPromise();
  }
}
